import { Component, OnInit } from '@angular/core';
import { AuthService, WMAIApiService, User, Word, AppInformationService } from '../core';
import { WgisService } from '../wgis/wgis.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators, NgForm } from '@angular/forms';
import { RoleEnum, EnumEx, } from '../core/models';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import * as foo from '../core/models/functions-cordova';

declare var $: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {

  isUserLoggedIn: boolean = false;
  results: User[] = [];
  username: string;
  currentPage = 1;
  totalPages: Array<number> = [1];
  resultsCount: number;
  searchModel: NgForm;
  pagesize: number = 10;
  limit: number = 10;
  loading: boolean = false;
  resultsVisible: boolean = true;
  rolesList: Word[] = [];
  userinfo: User;
  rolesFilter: string[];
  selectedUser: User;
  isMobile: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authservice: AuthService,
    private wgisservice: WgisService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private modalService: SuiModalService,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private appservice: AppInformationService
  ) {

    this.isUserLoggedIn = this.authservice.isUserLoggedIn();

    if (this.isUserLoggedIn == false)
      this.router.navigateByUrl('/login');
    this.userinfo = new User();
    this.isMobile = this.appservice.iAmMobile();
    // this.wmaiservice.queryUsers(localStorage.getItem('username')).subscribe(
    //   data => {
    //     if (data != null && data[0]['user_role'] != "admin")
    //       this.router.navigateByUrl('/login');
    //   }
    // )
    this.wgisservice.setMapInvisible();

    this.angulartics2.eventTrack.next({
      action: 'reset',
      properties: { label: 'UserFormReset' },
    });

    this.angulartics2.eventTrack.next({
      action: 'search',
      properties: { label: 'UserFormSearch' },
    });

    this.angulartics2.eventTrack.next({
      action: 'updateRolesSelected',
      properties: { label: 'UserFormUpdateRole' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showResults',
      properties: { label: 'UserShowResults' },
    });

    this.angulartics2.eventTrack.next({
      action: 'onEnableUser',
      properties: { label: 'UserEnableUser' },
    });

    this.angulartics2.eventTrack.next({
      action: 'onDisableUser',
      properties: { label: 'UserDisableUser' },
    });

    this.angulartics2.eventTrack.next({
      action: 'onSelectedUser',
      properties: { label: 'UserSelectUser' },
    });

  }

  ngOnInit() {
    $('#ruoli').dropdown();

    window.scrollTo(0, 0);
    this.getRolesList();
    this.search(null);
  }
  /**
   * si ottiene la lista di tutti i ruoli chiave
   */
  private getRolesList() {
    this.wmaiservice.getWordsByKeywordLocale('*', 'role').subscribe(data => {
      this.rolesList.push(...data);

    });
  }

  reset(form: NgForm) {
    form.reset();
    form.value.username = "";
    this.rolesFilter = [];
  }
  /** si fa un aricarca in base ai parametri passati dal form ed eseguendo una query attraverso questi parametri
   * si fanno ritornare i risulati e si vanno ad inserire all'interno di una tabella
   * @param  {NgForm|null} form
   */
  search(form: NgForm | null) {
    this.loading = true;
    if (form != null) {
      this.searchModel = form;
      this.totalPages = [1];
      // console.log(form.value);
      this.rolesFilter = [];
      for (var key in form.value) {
        if (form.value[key] == true) {
          this.rolesFilter.push(key);
        }
      }
      this.username = this.searchModel.value.username;
    } else {
      this.username = "";
      this.rolesFilter = [];
    }
    // console.log(this.rolesFilter);
    this.wmaiservice.queryUsers(this.username, this.rolesFilter, this.limit, this.currentPage).subscribe(
      data => {
        if (data != null) {
          this.results = data['data'];
          // console.log(this.results);
          if (data['metadata']['rowCount'] != null) {
            this.resultsCount = data['metadata']['rowCount'];
            let tmp = Math.ceil(this.resultsCount / this.limit);
            this.totalPages = this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
          this.loading = false;
        }
      }
    );
  }
  /**
   * si ottiene la lista degli utenti
   */
  getUsersList() {
    this.loading = true;

    this.wmaiservice.queryUsers(this.username, this.rolesFilter, this.limit, this.currentPage).subscribe(
      data => {
        if (data != null) {
          this.results = data['data'];
          if (data['metadata']['rowCount'] != null) {
            this.resultsCount = data['metadata']['rowCount'];
            let tmp = Math.ceil(this.resultsCount / this.limit);
            this.totalPages = this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
          this.loading = false;
        }
      });
  }

  setPageTo(pagenumber: number) {
    if (pagenumber != null) {
      this.results = [];
      this.currentPage = pagenumber;
      this.getUsersList()
    }
  }
  /**si cambia il ruolo attraverso i parametri passati
   * @param  {User} user
   * @param  {} selected
   */
  changeRole(user: User, selected) {
    if (user != null && selected.value != null) {
      if (user.userid != localStorage.getItem('username')) {
        let title: string = this.translateService.instant('modal.user.changeRole.title');
        let content: string = this.translateService.instant('modal.user.changeRole.content');
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Normal))
          .onApprove(() => {
            this.wmaiservice.updateRole(user.id, selected.value).subscribe(data => {
              user.user_role = selected.value;
            });
            this.selectedUser = null;
          })
          .onDeny(() => {
            selected.value = user.user_role;
          });
      }
    } else {
      selected.value = user.user_role;
    }
  }
  /** si abilita l'utente passato
   * @param  {User} user
   */
  onEnableUser(user: User) {
    if (user != null) {
      if (user.userid != localStorage.getItem('username')) {
        let title: string = this.translateService.instant('modal.user.enableUser.title');
        let content: string = this.translateService.instant('modal.user.enableUser.content');
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Normal))
          .onApprove(() => {
            this.wmaiservice.enableUser(user.userid).subscribe(data => {
              user.isenabled = true;
            });
            this.selectedUser = null;
          })
          .onDeny(() => "");
      }
    }
  }
  /** si disabilita l'utente passato
   * @param  {User} user
   */
  onDisableUser(user: User): void {
    if (user != null) {
      if (user.userid != localStorage.getItem('username')) {
        let title: string = this.translateService.instant('modal.user.disableUser.title');
        let content: string = this.translateService.instant('modal.user.disableUser.content');
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Normal))
          .onApprove(() => {
            this.wmaiservice.disableUser(user.userid).subscribe(data => {
              user.isenabled = false;
            });
            this.selectedUser = null;
          })
          .onDeny(() => "");
      }
    }
  }

  onSelectedUser(user: User) {
    if (user != null)
      this.selectedUser = user;
  }

  onUpdateRole(user: User, role: Word) {

  }
  /**
   * si esportano gli utenti con le statistiche tramite file
   */
  exportUser() {
    let title: string = this.translateService.instant('modal.esperienzaadmin.export.title');
    let content: string = this.translateService.instant('modal.esperienzaadmin.export.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.wmaiservice.queryUserStatistics().subscribe(data => {
          if (data != null) {
            if (!this.isMobile) {
              this.downloadFile(data, 'statisticheUtenti');
            } else {
              this.downloadFileMobile(data, 'statisticheUtenti');
            }
          }
        })
      })
      .onDeny(() => "");
  }
  /** si scarica il file in csv
   * @param  {} data
   * @param  {} filename='data'
   */
  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, ['Ruolo', 'Range eta', 'Genere', 'Nazione', 'Iscritto Alert', 'Accetto CC', 'Iscritto News', 'Utente Attivo', 'Lingua Usata'
    ]);
    // console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  /** si scarica il file mobile in csv 
   * @param  {} data
   * @param  {} filename
   */
  downloadFileMobile(data, filename) {
    let csvData = this.ConvertToCSV(data, ['Data di creazione della Esperienza', 'Data di ultima modifica della Esperienza', 'Stato della Esperienza', 'Scheda Id', 'Titolo Scheda',
      'Range eta', 'Genere', 'Iscritto Alert', 'Accetto CC', 'Iscritto News', 'Utente Attivo', 'Lingua Usata'
    ]);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    var device = this.appservice.getDeviceInfo();
    foo.saveBlobToFile(blob, filename, device).then((success) => {
      // let titlec: string = this.translateService.instant('modal.esperienzaadmin.export.title');
      // let contentc: string = this.translateService.instant('modal.esperienzaadmin.export.confirmcontent');
      // this.modalService
      //   .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      //   .onApprove(() => {
      //     // foo.openFile(success);
      //   })
      //   .onDeny(() => {
      //   });
    }).catch((error) => {
      console.log(error);
    });
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }

}
